import React, { useEffect, useState } from 'react'
import AffiliateLayout from './AffiliateLayout'
import DatePicker from 'react-date-picker'
import './index.css'
import { connectAffiliate } from './Affiliate.connect'

const AffiliateProfitLoss = ({ actions }) => {
  const [plData, setPlData] = useState(null)
  const currentDate = new Date()
  const date7DaysAgo = new Date(currentDate.setDate(currentDate.getDate() - 7))
  const [selectedDateFrom, setSelectedDateFrom] = useState(
    new Date(date7DaysAgo)
  )
  const [selectedDateTo, setSelectedDateTo] = useState(new Date())

  let todayDate = new Date()

  const getMonth = (date) => {
    return `${date.toLocaleDateString('en-GB', {
      month: '2-digit',
    })}`
  }

  const getDate = (date) => {
    return `${date.toLocaleDateString('en-GB', {
      day: '2-digit',
    })}`
  }

  const dateValidation = (from, to) => {}

  const getWithTimeLimit = () => {
    const DateFrom =
      selectedDateFrom && new Date(selectedDateFrom).setHours(0, 0, 0, 0)
    const DateTo =
      selectedDateTo && new Date(selectedDateTo).setHours(23, 59, 59, 999)
    dateValidation(DateFrom, DateTo)
  }

  const getAffUserSportWisePL = async () => {
    await actions
      .getAffUserSportWisePL({
        from_date: selectedDateFrom,
        to_date: selectedDateTo,
      })
      .then((res) => {
        setPlData(res?.data?.data?.response)
      })
      .catch((e) => console.log(e))
  }

  useEffect(() => {
    getAffUserSportWisePL()
  }, [])

  const handleSubmit = (e) => {
    e.preventDefault()
    getAffUserSportWisePL()
  }

  return (
    <AffiliateLayout>
      <div>
        <form className="typeslabel affiliate_filter openbettss affiliate-pl affiliate-report affi-date-filter-form">
          <div className=" account-statement-page__filter-content">
            <div className="account-statement-page__filters-date-input">
              <p>Date from:</p>
              <div>
                <DatePicker
                  onChange={setSelectedDateFrom}
                  value={selectedDateFrom}
                  locale={'en-US'}
                  showLeadingZeros={true}
                  clearIcon={null}
                  calendarIcon={null}
                  format={'dd/MM/yyyy'}
                  dayPlaceholder={getDate(todayDate)}
                  monthPlaceholder={getMonth(todayDate)}
                  yearPlaceholder={todayDate.getFullYear()}
                />
              </div>
            </div>
            <div className="account-statement-page__filters-date-input">
              <p>Date to:</p>
              <div>
                <DatePicker
                  onChange={setSelectedDateTo}
                  value={selectedDateTo}
                  locale={'en-US'}
                  showLeadingZeros={true}
                  clearIcon={null}
                  calendarIcon={null}
                  format={'dd/MM/yyyy'}
                  dayPlaceholder={getDate(todayDate)}
                  monthPlaceholder={getMonth(todayDate)}
                  yearPlaceholder={todayDate.getFullYear()}
                />
              </div>
            </div>
            <button
              className="account-statement-page__date-search-button"
              onClick={handleSubmit}
            >
              <span>Submit</span>
            </button>
          </div>
        </form>
        <div className="nw-affi-user-list-wrapper">
          <div className="table-responsive nw-affi-user-table">
            <table className="table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Event</th>
                  <th>Profit / Loss</th>
                </tr>
              </thead>
              <tbody style={{ background: '#fff' }}>
                {plData?.length > 0 ? (
                  plData?.map((item, index) => (
                    <tr key={index} className="user_list_tr">
                      <td
                        className="text-center text-nowrap"
                        style={{ textAlign: 'center', whiteSpace: 'nowrap' }}
                      >
                        {item?.date}
                      </td>
                      <td
                        className="text-center"
                        style={{ textAlign: 'center' }}
                      >
                        {item?.sport_name}
                      </td>
                      <td
                        className={`text-center `}
                        style={{
                          color: item?.user_pl > 0 ? 'green' : 'red',
                          textAlign: 'center',
                        }}
                      >
                        {item?.user_pl}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr className="tabetdat">
                    <td
                      colSpan={3}
                      style={{ width: '100%', textAlign: 'center' }}
                    >
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </AffiliateLayout>
  )
}

export default connectAffiliate()(AffiliateProfitLoss)
